// extracted by mini-css-extract-plugin
module.exports = {"Answer":"Answer-module--Answer--2V6aj","Text":"Answer-module--Text--3Floh","Correct":"Answer-module--Correct--10kSw","InCorrect":"Answer-module--InCorrect--3MHrI"};